<template>
  <div class="video">
    <video
      v-if="list.length > 0"
      style="width: 100%; height: 220px; object-fit: fill; display: block;"
      :poster="list[0].pictureUrl"
      :src="list[0].url"
      controls
      autobuffer
    ></video>
    <div
      class="video-children"
      v-if="list.length > 1"
      :style="{'border-bottom': '1px dashed #fff'}"
      @click="goVideoList"
    >
      <div class="video-children-left">
        <img src="../../assets/video-icon.png" class="video-icon" />
        <span class="video-title">{{list[1].name}}</span>
      </div>
      <div class="video-children-rigth">
        <img src="../../assets/more-icon-white.png" class="video-icon-more" />
        <span class="video-icon-text">更多</span>
      </div>
    </div>
    <div class="video-children" v-if="list.length > 2" @click="goVideoList">
      <div class="video-children-left">
        <img src="../../assets/video-icon.png" class="video-icon" />
        <span class="video-title">{{list[2].name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array
  },
  methods: {
    goVideoList() {
      this.$router.push({ name: "videoList" });
    }
  }
};
</script>

<style lang="scss" scoped>
.video {
  width: 384px;
  height: 316px;
  padding: 16px 16px 0 16px;
  float: left;
  margin-top: 16px;
  background: linear-gradient(
    135deg,
    rgba(254, 179, 57, 1) 0%,
    rgba(242, 139, 56, 1) 100%
  );
  &-children {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: white;
    &-left {
      float: left;
    }
    &-rigth {
      float: right;
      cursor: pointer;
    }
  }
  &-icon {
    width: 16px;
    height: 16px;
    margin: 0 16px 0 8px;
    vertical-align: middle;
    &-more {
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }
    &-text {
      vertical-align: middle;
      margin-left: 6px;
    }
  }
  &-title {
    vertical-align: middle;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
